import normalizeDateInput from './normalizeDateInput'
import formatCampaignDateKey from './formatCampaignDateKey'
import parseDateFromCampaignTitle from './parseDateFromCampaignTitle'

export const resolveCampaignDateKey = (values = {}, contextDate = new Date()) => {
  const relatedIsoDate = normalizeDateInput(values.related_promo_start_date)

  if (relatedIsoDate) {
    return {
      source: 'related_promo',
      isoDate: relatedIsoDate,
      dateKey: formatCampaignDateKey(relatedIsoDate),
    }
  }

  const manualIsoDate = normalizeDateInput(values.campaign_date)

  if (manualIsoDate) {
    return {
      source: 'campaign_date',
      isoDate: manualIsoDate,
      dateKey: formatCampaignDateKey(manualIsoDate),
    }
  }

  const parsed = parseDateFromCampaignTitle(values.title, contextDate)

  if (parsed?.isoDate) {
    return {
      source: 'title',
      isoDate: parsed.isoDate,
      dateKey: formatCampaignDateKey(parsed.isoDate),
    }
  }

  return {
    source: null,
    isoDate: null,
    dateKey: null,
  }
}

export default resolveCampaignDateKey
